var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cta_devenir_valet"},[_c('a',{staticClass:"frame-1",staticStyle:{"text-decoration":"none"},attrs:{"href":"https://recrutement.popvalet.com/"}},[_c('div',{staticClass:"accs-valet blogtextbold"},[_vm._v(_vm._s(_vm.accsValet))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }